/**
 * Window Visibility Utilities - Web Version
 *
 * Stub implementations for browser environment.
 * In web, window management is handled by the browser.
 */

/**
 * Toggle window visibility (same behavior as Ctrl+Enter)
 *
 * Web version: No-op since browser tabs/windows are controlled by the browser
 *
 * @param windowControls - The window controls from useElectron()
 * @returns Promise that resolves immediately
 */
export async function toggleWindowVisibility(windowControls: {
  toggleVisibility: () => Promise<{ success: boolean; error?: string }>;
}): Promise<void> {
  // No-op in web - browser handles window visibility
  await windowControls.toggleVisibility();
}

/**
 * Adjust window height to the minimum height
 *
 * Web version: No-op since browser windows don't need dynamic resizing
 * The browser's layout engine handles content height automatically
 *
 * @param minHeight - The minimum height (unused in web)
 * @returns Promise that resolves immediately
 */
export async function adjustWindowHeight(minHeight: number): Promise<void> {
  // No-op in web - browser handles layout automatically
  // The parameter is kept for API compatibility
  void minHeight;
}
